<template>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
        <div class="selected" :class="{ open: open }" @click="open = !open">
            {{ selected }}
        </div>
        <div class="items " :class="{ selectHide: !open }">
            <div class="wrap">
            <div
                v-for="(option, i) of options"
                :key="i"
                @click="
          selected = option.tabName;
          open = false;
          // $emit('input', option.tabName);
          $emit('updateTabsMobile', option,i);
        "
                :class="['option-wrap',]"
            >
                <div :class="['c-tabs__btn',selected == option.tabName? 'c-tabs__btn--active':'']">{{
                        option.tabName
                    }}
                </div>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        default: {
            type: String,
            required: false,
            default: null,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            selected: this.default
                ? this.default
                : this.options.length > 0
                    ? this.options[0].tabName
                    : null,
            open: false,
        };
    },
    mounted() {
    },
};
</script>

<style scoped>
.custom-select {
    position: relative;
    width: 100%;
    text-align: left;
    outline: none;
    height: 47px;
    line-height: 47px;
}

.custom-select .selected {
    border-radius: 2px;
    box-shadow: 0 0 2px rgb(204, 204, 204);
    transition: all .5s ease;
    position: relative;
    font-size: 14px;
    color: #474747;
    height: 100%;
    text-align: left;
    cursor: pointer;
    user-select: none;
    padding-left: 10px;
}

.custom-select .selected.open {
    border-radius: 6px 6px 0px 0px;
}

.custom-select .selected:after {
    position: absolute;
    content: "";
    top: 22px;
    right: 1em;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-color: #888 transparent transparent transparent;
}


.custom-select .items {
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
}

.custom-select .items {
    color: #595959;
    overflow: hidden;
    position: absolute;
    background-color: #fff;
    left: 0;
    right: 0;
    z-index: 1;
    width: 100%;
    margin-top: 1px;
    box-shadow: 0 1px 2px rgb(204, 204, 204);
    border-radius: 0 1px 2px 2px;
    max-height: 144px;
    overflow-y: auto;
    text-align: left;
    padding: 10px 0;
    transition: all .5s ease
}

.custom-select .items .wrap div {
    color: #595959;
    cursor: pointer;
    user-select: none;
    text-align: center;
}

.custom-select .items .wrap div:hover {
    background-color: #f2f2f2;
}

.custom-select .items.selectHide {
    display: none;
}

.custom-select .c-tabs__btn {
    width: 90%;
    max-width: 90%;
}

.custom-select div.c-tabs__btn.c-tabs__btn--active {
    color: #fff;
}

.comda .custom-select .c-tabs__btn--active {
    background-color: #0072BC !important;

}

.comda .custom-select .c-tabs__btn {
    font-family: "Open Sans", sans-serif;
}

.mlp .custom-select .c-tabs__btn--active {
    background-color: #009444 !important;
}

.mlp .custom-select .c-tabs__btn {
    font-family: 'museo-sans', sans-serif;
}

.custom-select .c-tabs__btn {
    border: 2px solid #d7d7d7;
}

.custom-select .option-wrap {
    width: 100%;
    max-width: 210px
}

.custom-select .option-wrap:hover > div {
    background-color: #f2f2f2;
    text-decoration: underline;

}

.custom-select {
    display: none;
}
.custom-select .items .wrap{
    max-height: 144px;
    width: 100%
}

@media only screen and (max-width: 768px) {
    .custom-select {
        display: block;
        margin-bottom: 10px;
    }
}

@media only screen and (max-width: 600px) {
    .custom-select .option-wrap {
        max-width: 100%;
    }

    .custom-select .c-tabs__btn {
        font-size: 16px;
        font-weight: 400;
    }

    .custom-select .option-wrap div.c-tabs__btn {
        /*border: none;*/
        text-align: left;
        padding: 7px 12px;
        width: 95%;
        max-width: 95%;
    }
}

</style>
